import { useState } from 'react'
import type { TenantConfig } from '@webmono/storefront-ui/types'

interface TenantSwitcherProps {
  tenants: Record<string, TenantConfig>
  currentTenantId: string
  onTenantChange: (id: string) => void
}

export function TenantSwitcher({ tenants, currentTenantId, onTenantChange }: TenantSwitcherProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="fixed bottom-4 right-4 z-[9999]">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 bg-gray-900 text-white px-4 py-2 rounded-full shadow-lg hover:bg-gray-800 transition-colors text-sm font-medium"
      >
        <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
        Demo Mode
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-[9998]"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute bottom-full right-0 mb-2 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden min-w-[280px] z-[9999]">
            <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
              <h3 className="font-semibold text-gray-900 text-sm">Switch Restaurant</h3>
              <p className="text-xs text-gray-500 mt-0.5">Demo different white-label configurations</p>
            </div>
            <div className="p-2">
              {Object.entries(tenants).map(([id, tenant]) => (
                <button
                  key={id}
                  onClick={() => {
                    onTenantChange(id)
                    setIsOpen(false)
                  }}
                  className={`w-full flex items-center gap-3 px-3 py-2 rounded-md transition-colors text-left ${
                    id === currentTenantId
                      ? 'bg-gray-100'
                      : 'hover:bg-gray-50'
                  }`}
                >
                  <img
                    src={tenant.branding.logo}
                    alt={tenant.name}
                    className="w-10 h-10 rounded-lg object-cover border border-gray-200"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="font-medium text-gray-900 text-sm truncate">
                      {tenant.name}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      {tenant.tagline}
                    </div>
                  </div>
                  {id === currentTenantId && (
                    <div className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0" />
                  )}
                </button>
              ))}
            </div>
            <div className="px-4 py-3 bg-gray-50 border-t border-gray-200">
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                This switcher is for demo purposes only
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
